import {applyMiddleware, createStore, Middleware} from "redux";
import { createLogger } from "redux-logger";
import {thunk} from "redux-thunk";
import { createWrapper } from "next-redux-wrapper";
import { rootReducer } from "./redux";
import { RootAction, RootState } from "./redux/redux-types";

import {persistReducer, persistStore} from "redux-persist";

const bindMiddleware = (middleware) => {
  return applyMiddleware(...middleware);
};

const makeStore = (
  initialState: RootState | undefined = undefined,
 
) => {
  // Add any middlewares here

  const middlewares: any[] = [thunk];

  // Add any dev only middlewares here
  const devMiddlewares = [createLogger()];

  if ( typeof window === "undefined") {
    return createStore(
      rootReducer,
      initialState,
      applyMiddleware(...middlewares)
    );
  } else {

    const storage = require("redux-persist/lib/storage").default;
    if (process.env.NODE_ENV !== `production`) {
      devMiddlewares.forEach((mw) => {
        middlewares.push(mw);
      });
    }
    const persistConfig = {
      key: "nextjs",
//      whitelist: ["app"], // only x will be persisted, add other reducers if needed
      storage,
    };
    const persistedReducer = persistReducer(persistConfig, rootReducer); // Create a new reducer with our existing reducer
    const store = createStore(persistedReducer, bindMiddleware(middlewares));

    // TODO HACK?
    (store as any).__persistor = persistStore(store);

    return store;
  }
};

// Export the wrapper & wrap the pages/_app.js with this wrapper only
export const wrapper = (createWrapper as any)(makeStore);
